var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCallUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_33933",
    "data-name": "Group 33933",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13713",
    "data-name": "Rectangle 13713",
    width: 18,
    height: 18,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33497",
    "data-name": "Group 33497",
    transform: "translate(1.249 3.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M333.21,290.214a2.631,2.631,0,0,1-2.574,2.7c-.11,0-5.44-.005-5.44-.005a2.655,2.655,0,0,1-2.886-2.373c-.009-.106-.007-5.826-.007-5.826a2.633,2.633,0,0,1,2.571-2.7c.111-.005,5.434,0,5.434,0a2.667,2.667,0,0,1,2.9,2.388C333.212,284.5,333.21,290.214,333.21,290.214Z",
    transform: "translate(-322.3 -282)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M336.3,286.323l2.567-2.1a.973.973,0,0,1,1.589.754l-.009,5.728a.973.973,0,0,1-1.59.75l-2.556-2.1",
    transform: "translate(-325.388 -282.441)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCallUsage);
export default __webpack_public_path__ + "static/media/video-call-usage.47190cd2.svg";
export { ForwardRef as ReactComponent };